
import { defineComponent } from "vue";
const JobsEmptyState = defineComponent({
  name: "JobsEmptyState",
});

export default JobsEmptyState;
